import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Field({ label, helper, error, className, children, ...rest }) {
    return (_jsxs("label", { className: cn("fwfa-field", className), ...rest, children: [_jsx("span", { className: "fwfa-label", children: label }), children, helper !== undefined && (_jsx("span", { className: cn("fwfa-helper", error && "fwfa-helper--error"), children: helper }))] }));
}
//# sourceMappingURL=Field.js.map